import React from 'react';
import ProductHeaderDesktop from './components/header-desktop';
import { ProductHeaderMobile } from './components/header-mobile';
import { ProductHeaderProps } from './types';
import Viewport from '../../../../components/viewport';

export const ProductHeader = React.memo((props: ProductHeaderProps) => {
  return (
    <>
      <Viewport desktop tablet>
        <ProductHeaderDesktop {...props} />
      </Viewport>
      <Viewport mobile>
        <ProductHeaderMobile {...props} />
      </Viewport>
    </>
  );
});
